<template>
  <page-outline :title="$t('acceptance.rules_exception')">
    <template slot="pageContent">
      <div class="listPage" style="overflow:hidden;">
        <b-row class="form-group justify-content-start showLargeScreenOnly">
          <b-col cols="1">
            <b-button class="btn btnFilter" :disabled="activateSpinner"
              @click="refreshInbox()">
              <i class="fa-light fa-rotate-right"></i>
              <!-- <span class="fab-label">{{ $t('common.rfrsh') }}</span> -->
            </b-button>
          </b-col>
          <!-- <b-col cols="2">
            <b-button class="btn" :disabled="activateSpinner"
              @click="exportVerifications()">
              <i class="fa-light fa-cloud_download"></i>
              <span class="fab-label">{{ $t('common.exprt') }}</span>
            </b-button>
          </b-col> -->
        </b-row>

        <b-row>
          <b-col>
            <div class="requestsList">
              <div style="margin-top:0">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else style="overflow-x:auto;">
                  <table class="table">
                    <thead>
                      <th class="text-center" style="width:6%">
                        {{ $t('Acceptance') }}
                      </th>
                      <th class="text-center" style="width:10%">
                        {{ $t('acceptance.company_admin_state') }}
                      </th>
                      <th class="text-center" style="width:10%">
                        {{ $t('acceptance.establish_admin_state') }}
                      </th>
                      <th class="text-center" style="width:10%">
                        {{ $t('acceptance.act_autorization')}}
                      </th>
                      <th class="text-center" style="width:10%">
                        {{ $t('acceptance.legal_process') }}
                      </th>
                      <th class="text-center" style="width:7%">
                        {{$t('acceptance.vat_nb_validity') }}
                      </th>
                      <th class="text-center" style="width:11%">
                        {{$t('acceptance.is_in_registry') }}
                      </th>
                      <th class="text-center" style="width:9%">
                        {{ $t('acceptance.company_stability') }}
                      </th>
                      <th class="text-center" style="width:10%">
                        {{$t('acceptance.available_status')}}
                      </th>
                      <th class="text-center" style="width:12%">
                        {{ $t('acceptance.status') }}
                      </th>
                      <th class="text-center" style="width:7%">
                        {{ $t('acceptance.actions') }}
                      </th>
                    </thead>
                    <tbody>
                      <template v-if="inboxMessages.length > 0">
                        <tr v-for="result in inboxMessages"
                          class="boxRequest">
                          <td class="text-center" :title="result.score" v-html="getLabel(result.scores)">  </td>
                          <td class="text-center" :title="result.comp_state" v-html="getCodeLabel('comp_state', result.comp_state)"></td>
                          <td class="text-center" :title="result.etab_state" v-html="getCodeLabel('etab_state', result.etab_state)"></td>
                          <td class="text-center" :title="result.activity" v-html="getCodeLabel('activity', result.activity)"></td>
                          <td class="text-center" :title="result.legal_process" v-html="getCodeLabel('legal_process', result.legal_process)"></td>
                          <td class="text-center" :title="result.tva" v-html="getCodeLabel('tva', result.tva)"></td>
                          <td class="text-center" :title="result.inscription" v-html="getCodeLabel('inscription', result.inscription)"></td>
                          <td class="text-center" :title="result.status" v-html="getCodeLabel('status', result.status)"></td>
                          <td class="text-center" :title="result.stability" v-html="getCodeLabel('stability', result.stability)"></td>
                          <td class="text-center" :title="getKYCVerificationsStatus(result.final_status)">
                            <!-- <b-container fluid> -->
                              <b-row>
                                <b-col cols="2">
                                  <i class="icon list-icon" :class="getKYCVerificationsIcon(result.final_status)"></i>
                                </b-col>
                                <b-col cols="10">
                                  <span style="margin-left:-20px;">{{ getKYCVerificationsStatus(result.final_status) }}</span>
                                </b-col>
                              </b-row>
                            <!-- </b-container> -->
                          </td>
                          <td class="text-center">
                            <span class="fileClickButton mr-4 cursor"
                              @click="editException(result.id_kyc_validation)">
                              <!-- {{ $t('common.edit_label') }} -->
                              <i class="fa-light fa-pencil"></i>
                            </span>
                            <span class="fileClickButton"
                              @click="deleteException(result.id_kyc_validation)">
                              <!-- {{ $t('common.del_label') }} -->
                              <i class="fa-light fa-trash"></i>
                            </span>
                          </td>
                        </tr>
                      </template>

                      <tr v-else>
                        <td colspan="12" class="noResult">
                          {{ $t('common.no_result') }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="2" offset="10">
            <b-button variant="primary"
              size="lg"
              @click="addException()">
              <i class="fa-light fa-plus"></i>
              <span>{{ $t('acceptance.add') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import MessagesFilter from '@/components/common/Filter'
import Spinner from '@/components/common/spinner.vue'
import pageOutline from '@/components/common/PageOutline.vue'

import { errorMessageAlert } from '@/helpers/alert'
import { statusIcon, statusLabel } from '@/helpers/labels'
import { loadPage } from '@/helpers/routing'
import supplierCodeList from '@/data/suppliercode.json'

export default {
  name: 'VerificationsListPage',
  components: {
    'cm-messages-filter': MessagesFilter,
    'spinner': Spinner,
    'page-outline': pageOutline
  },
  props: {
    direction: {
      default: '2',
      type: String
    },
    modeFilter: {
      default: '1',
      type: String
    }
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    }
  },
  data () {
    return {
      activateSpinner: false,
      filterBy: '',
      inboxMessages: [],
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      comp_state: '',
      etab_state: '',
      activity: '',
      legal_process: '',
      tva: '',
      inscription: '',
      status: '',
      stability: '',
      final_status: '',
      id: '',
      score: '',
      supplierCodeList: supplierCodeList
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Vérifications',
      returnUrl: ''
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 13
    this.paginationObject['nbResultsTotal'] = 0

    this.mode = parseInt(this.modeFilter, 10)
    let that = this
    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.$engine.settings.set({msgDirection: this.direction})

    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
  },
  methods: {
    getLabel (value) {
      console.log(value)
      switch(value) {
        case '1':
          return '<i class="fa-solid fa-check text-success"></i>'
        case '0':
          return '<i class="fa-solid fa-xmark text-danger"></i>'
        default:
          return '-'
      }
    },
    getCodeLabel (tab, value) {
      var foundLabel = ''
      this.supplierCodeList[tab].map(supplierCode => {
        if (value === supplierCode.code) {
          foundLabel = supplierCode.label
        }
      })
      if (foundLabel === '') {
        foundLabel = value
      }

      switch(foundLabel) {
        case 'valide':
          return '<i class="fa-solid fa-check text-success"></i>'
        case 'avertissement':
          return '<i class="fa-solid fa-warning text-warning"></i>'
        case 'invalide':
          return '<i class="fa-solid fa-xmark text-danger"></i>'
        default:
          return '-'
      }
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        // this.$$('.infinite-scroll').append(
        // '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        // )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    getKYCVerificationsIcon (status) {
      return statusIcon('KYCVerifications_' + status)
    },
    getKYCVerificationsStatus (status) {
      return statusLabel(this.$i18n, 'KYCVerifications_' + status)
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onInfinite () {
      if (this) {
        return
      }
      if (this.scrollFlag) {
        this.scrollFlag = false
        let that = this
        this.pageCounter = this.pageCounter + 1
        this.paginationObject['firstIndex'] = this.pageCounter * this.paginationObject['maxResults'] + 1
        this.paginationObject['nbResultsTotal'] = 0

        // let filterConditions
        // if (this.$engine.verifications.filter.getDefaultFilter()) {
        //   filterConditions = this.$engine.verifications.filter.getDefaultFilter()
        // } else {
        //   filterConditions = this.$engine.verifications.filter.getConditionObject()
        // }
        this.$engine.supplierss.getKYCVal()
        .then(resp => {
          let requests = {}
          that.requestsNumber = resp.data.actionHistory.length
          requests = resp.data.KYCExceptions
          that.paginationObject.nbResults = that.requestsNumber

          if (requests.length > 0) {
            for (let i = 0; i < requests.length; i++) {
              that.inboxMessages.push(requests[i])
            }
            if (requests.length < this.paginationObject['maxResults']) {
              that.detachInfinit()
            }
          } else {
            that.detachInfinit()
          }
          that.scrollFlag = true
        })
        .catch(error => {
          errorMessageAlert(error, that, that.$i18n)
          that.scrollFlag = true
        })
      }
    },
    onRefresh (noAttach = false, index = 1) {
      // const that = this
      this.pageCounter = 0
      // this.scrollFlag = true
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions
      // if (this.$engine.history.filter.getDefaultFilter()) {
      //   filterConditions = this.$engine.verifications.filter.getDefaultFilter()
      // } else {
      //   filterConditions = this.$engine.verifications.filter.getConditionObject()
      // }
      this.$engine.services.suppliers.getKYCVal()
      .then(resp => {
        let requests = {}
        this.paginationObject.nbResults = resp.data.KYCExceptions.length
        requests = resp.data.KYCExceptions
        this.updateInbox(requests, noAttach)
        this.$f7.pullToRefreshDone()
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    checkStatus (name, tab) {
      if (tab.score_req[name + '_req'] === '1') {
        if (tab[name + '_score'] !== '' && parseInt(tab[name + '_score']) < parseInt(tab.score_min[name])) {
          return false
        }
      }
      return true
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    // redirectDetails (entity) {
    //   entity.verify = false
    //   this.$engine.services.suppliers.selectedEntity = entity
    //   console.log(entity)
    //   loadPage(this, { url: '/verifications/details/' })
    // },
    refreshInbox () {
      this.onRefresh()
    },
    updateInbox (requests, noAttach = false) {
      this.inboxMessages = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    addException () {
      let that = this
      loadPage(that, {url: '/addkycexceptions/'})
    },
    editException (id) {
      let that = this
      loadPage(that, {url: '/editkycexceptions/' + id})
    },
    deleteException (id) {
      let that = this
      this.$f7.modal({
        title: this.$t('acceptance.del'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$engine.services.suppliers.deleteKYCVal(id)
              .then(resp => {
                that.onRefresh()
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
